

























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import { ShopItemOptionCardDefinition } from "@/store/states/ShopState";
import { CartState } from "@/store/states/CartState";
import axios from "axios";

@Component
export default class CardImageOption extends Vue {
  @State("cart") cart: CartState;
  @Action("setOption", { namespace: "cart" }) setOption: Function;

  @Prop({ required: true })
  public onChange: Function;

  @Prop({ required: true })
  public currentOption!: ShopItemOptionCardDefinition;

  public file: File = null;
  public warning = "";
  public showWarning = false;
  public customized = "no";

  @Watch("customized")
  onPropertyChanged(value: string, oldValue: string) {
    if (value=="no" && oldValue !== "no") {
      this.useDefaultCard();
    }
  }

  get currentCardURL() {
    if (this.cart.current.itemOptions[this.currentOption.uuid]) {
      return (
        process.env.VUE_APP_BACKEND_URL +
        "/card/" +
        this.cart.current.itemOptions[this.currentOption.uuid]["card"]
      );
    } else {
      return "";
    }
  }

  get isCurrentCardTheDefaultOne() {
    if (this.cart.current.itemOptions[this.currentOption.uuid] !== undefined) {
      return (
        this.cart.current.itemOptions[this.currentOption.uuid]["card"] ===
        process.env.VUE_APP_DEFAULT_CARD_UUID
      );
    }
    return true;
  }

  public useDefaultCard() {
    this.setOption({
      itemOptionUuid: this.currentOption.uuid,
      optionKey: "card",
      optionValue: process.env.VUE_APP_DEFAULT_CARD_UUID,
    });
    this.file = null;
    this.customized = "no";
    this.onChange();
  }

  public uploadCard() {
    const formData = new FormData();
    formData.append("image", this.file);
    if (this.file) {
      if (this.file.size <= 2000000) {
        axios
          .post(process.env.VUE_APP_BACKEND_URL + "/card", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            this.setOption({
              itemOptionUuid: this.currentOption.uuid,
              optionKey: "card",
              optionValue: response.data["uuid"],
            });
            this.showWarning = false;
            this.customized = "yes";
            this.onChange();
          })
          .catch((error) => {
            if (error.response) {
              this.warning = error.response.data.error;
              this.showWarning = true;
              this.file = null;
            }
          });
      } else {
        this.warning = "error.card.file.size";
        this.showWarning = true;
        this.file = null;
      }
    }
  }
}
